import {
    // GoogleLogin,
    useGoogleLogin
} from '@react-oauth/google';
import { useDispatch } from 'react-redux';

import { googleToken } from '../../../actions/user';
import { basicMsg } from '../../../actions/swal_msg';

import { Button } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

const GoogleLoginButton = () => {
    const dispatch = useDispatch();
    // const responseMessage = (response) => {
    //     console.log(response);
    // };
    // const errorMessage = (error) => {
    //     console.log(error);
    // };

    const login = useGoogleLogin({
        onError: async errorResponse => {
            basicMsg('No se pudo continuar con Google');
        },
        onSuccess: async tokenResponse => {
            if (tokenResponse) {
                const { access_token, expires_in } = tokenResponse;
                dispatch(googleToken(access_token, expires_in));
            }
        }
    });

    return (
        // <GoogleLogin
        //     onSuccess={ responseMessage } onError={ errorMessage }
        //     size='large' width={200}
        // />
        <Button variant="outlined" endIcon={<GoogleIcon />}
            sx={{ width: '100%', height: '55px', fontWeight: '600' }}
            onClick={ login }>
            Continuar con Google
        </Button>
    );
};

export default GoogleLoginButton;